import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  token: localStorage.getItem('token') || ''
}

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.baseURL = (process.env.NODE_ENV === 'production')
? 'https://api.myfests.ru'
: 'http://api.myfests.loc';

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  auth_request(state){
    state.status = 'loading'
  },
  auth_success(state, token){
    state.status = 'success'
    state.token = token
  },
  auth_error(state){
    state.status = 'error'
  },
  logout(state){
    state.status = ''
    state.token = ''
  }
}

const actions = {
  login({commit}, user){
    return new Promise((resolve, reject) => {
      commit('auth_request')
      let req = {
        username: user.email,
        password: user.password,
        grant_type: "password",
        client_id: 3,
        scope: ""
      }
      axios({url: '/api/auth/token', data: req, method: 'POST' })
      .then(resp => {
        console.info(resp.data)


        const token = resp.data.access_token
        localStorage.setItem('token', token)
        axios.defaults.headers.common['Authorization'] = 'Bearer '+token
        commit('auth_success', token)
        resolve(resp)
      })
      .catch(err => {
        console.log("ERROR")
        commit('auth_error')
        localStorage.removeItem('token')
        reject(err)
      })
    })
  },
  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
      authStatus: state => state.status,
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})